import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/App';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { IReduxStore } from '../../../shared/types/redux';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const {
    config,
    custom: { initialDeviceType },
  } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <UiKitRoot deviceType={initialDeviceType} useStaticDeviceType>
      <Application context={context} reduxStore={store} />
    </UiKitRoot>,
  );
}
